angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsWorkspaceCard', function ($log, $q, $sce, Firebase, EventManager, language, TeacherDataService) {
  return {
    templateUrl: 'template.html',
    scope: {
      log: '=',
      classId: '=',
      selectedStudent: '=?',
      prevlog: '=',
      studentsList: '=',
      resourceListing: '=',
      parentResource: '=',
      nextlog: '='
    },
    link: function (scope) {
      var eventManager = new EventManager('workspace_card', scope);

      scope.getTranslation = function(id, fallbackText){
        if (fallbackText) {
          return language.get(id) !== "NA" ? language.get(id) : fallbackText;
        }
        return language.get(id);
      }

      scope.shouldShowStudentName = function(){
        if (!scope.prevlog || scope.log.user_id !== scope.prevlog.user_id ){
          return true;
        }
        return false
      }

      scope.shouldShowLoadMore = function(){
        if (scope.nextlog === true || (scope.nextlog && scope.log.user_id !== scope.nextlog.user_id )){
          return true;
        }
        return false
      }

      scope.filterToStudent = function(){
        eventManager.broadcast('response:tab:options', {student:{user:infoMaps.users[scope.log.user_id]}})
      }

      scope.moment = moment;

      var infoMaps = {
          users: {},
          resources: {}
      }
      var runLikeMathModuleId = 192;
      scope.loadingStatus = {
          done: false,
          failed: false,
          processing: false
      }
      scope.rowData = {
          inProgress: false,
          isComplete: false,
          studentName: '',
          resourceName: '',
          date: '',
          year: '',
          timeStarted: '',
          time: '',
          timeText: '',
          completeText: '',
          text: '',
          compiledTimeSentenceID: '',
          cardStyle: {
              // 'padding': '4px'
          },
          timeClass: {}
      };

      var min2digit = function(str){
        if ( (''+str).length < 2 ){
          return '0'+str;
        }
        return str;
      }

      scope.returnTimeSpent = () => {
        scope.time_spent = Number(moment(scope.log.timeSpent))/1000; //(Number(moment(scope.log.timeEnded)) - Number(moment(scope.log.timeStarted)))/1000;
        scope.time_spent = Math.max(0, Math.min(scope.time_spent, 1200))
        scope.time_text = min2digit(Math.floor(scope.time_spent/60)) + ':' + min2digit(Math.min(59, Math.round(scope.time_spent%60)));
        return scope.time_text;
      }


      scope.getResultPercentage = () =>  Math.round(scope.log.score*100) + '%';

      if(scope.log.score){
        scope.score_text = scope.getTranslation('27745') + ' ' + Math.round(scope.log.score*100) + '%'; // 'score:'
      }

    var getStarsFromScore = function(score,maxStars){
      var stars = 0;      
      var parent = scope.parentResource;
      var scoring = {'0.5': 1, '0.8': 2, '1': 3}
      if(parent && parent.config.map_config && parent.config.map_config.item_scoring_breakdown){
        scoring = parent.config.map_config.item_scoring_breakdown;
      }

      //this is hard coded for the old rlm module
      if(scope.parentResource.parent_resource_id===runLikeMathModuleId){
        scoring = {'0.25': 1, '0.5': 2, '0.75': 3, '1': 4}
      }

      var max_scoring_found = 0;
      for(var score_point in scoring){
        if(scoring[score_point] && score >= Number(score_point) && Number(score_point) > max_scoring_found ){
          stars = scoring[score_point];
          max_scoring_found = Number(score_point);
        }
      }

      var result = Math.min(stars,maxStars);
      return result;
    }

    function getCompleteStarCount(resource){
      if (resource && resource.display && scope.log.completed && resource.resource_type !== "assessment")
      {
        var max_stars = resource.display.color === 'blue' ? 1 : 3;
        var num = getStarsFromScore(scope.log.score,max_stars);//Math.floor(scope.log.score * max_stars);
        scope.completeStarCount =  num === 0 ? [] : setupNumArray(num);

      } else {
        scope.completeStarCount =  [];
      }
    }

    function getMaxStarCount(resource) {
      if (resource.resource_type === "assessment" || !resource.display || !scope.log.completed){
        scope.maxStarCount = [];
      }
      else{
        var num = scope.completeStarCount.length || 0
        if (resource.display.color === 'blue'){
          scope.maxStarCount = setupNumArray(1 - num);
        }
        else {
          scope.maxStarCount = setupNumArray(3 - num);
        }
      }
    }

    function setupNumArray(num){
      var arr = [];
      for(var i  = 0 ; i < num; i ++){
        arr.push(i);
      }
      return arr;
    }

    scope.getName = function(log){
      if(log.resource_type === 'custom_resource'){
        return log.name;
      }
      if(log.slug.indexOf('run_like_math') === -1){
        return language.get(log.slug)
      }else{
        var splt = log.slug.split('_');
        var level = '';
        if(!isNaN(splt[splt.length-1])){
          level = splt[splt.length-1];
        }
        var trans_slug = log.slug.replace('_'+level, '');
        // if(log.slug.indexOf('subtraction') > -1){   But why
        //   if(level === '3'){
        //     level = '1'
        //   }else if(level === '1'){
        //     level = '3';
        //   }
        // }
        return language.get(trans_slug+'_short').replace('__', level);
      }
    }

    scope.getFormattedTime = function(){
      return moment(scope.rowData.timeStarted).format('MMM DD')+', '+moment(scope.rowData.timeStarted).format('YYYY');
    }

    var parseLog = function(log){
      scope.loadingStatus.done = false;
      scope.loadingStatus.error = false;
      scope.loadingStatus.processing = true;
      var student = infoMaps.users[log.user_id] || {};
      var resource = scope.resourceListing || {};
      // scope.rowData.date = moment(log.timeStarted).format('MMM DD')
      // scope.rowData.year = moment(log.timeStarted).format('YYYY');

      if(scope.rowData.year < 2000 && log.alternative_start){
        log.timeStarted = log.alternative_start;
        // scope.rowData.date = moment(log.timeStarted).format('MMM DD')
        // scope.rowData.year = moment(log.timeStarted).format('YYYY');
        //console.log('replacing wrong date!', log )
      }
      
      scope.rowData.timeStarted = log.timeStarted;
      
      

      var currentHour = Number(moment(log.timeStarted).format('H'));
      var timeText = '';
      if( currentHour >= 7 && currentHour < 12 ) {
        timeText = '27731' // Morning
      }
      else if (currentHour >= 12 && currentHour < 17) {
        timeText = '27732' // 'Afternoon'
      }
      else {
        timeText = '27733' // 'Evening &amp;<br> Weekend'
        scope.rowData.timeClass['studentCard__time--evening'] = true
      }
      scope.rowData.time = timeText;
      scope.rowData.timeText = moment(log.timeStarted).locale('en').fromNow(true);
      // scope.rowData.timeAgo = String(scope.rowData.timeText).incudes('days') ? 'days' : 'months';
      // scope.rowData.timeAgo = scope.rowData.timeText.indexOf('days') > 0 ? 'days' : 'months';
      // scope.rowData.timeAgo = 'days';
      scope.rowData.typeOf = typeof(scope.rowData.timeText);
      scope.rowData.timeAgoNumber = moment(log.timeStarted).locale('en').fromNow(true).match(/\d+/) || '1';
      if (!log.timeEnded ){
          scope.rowData.inProgress = true
          //scope.rowData.timeText = moment(log.timeEnded).fromNow()
      }
      else if (moment().diff(moment(log.timeStarted),'hours') > 5)  {
        scope.rowData.inProgress = false
      }
      else {
        scope.rowData.inProgress = false
      }
      if(!scope.rowData.inProgress) {
        scope.rowData.isComplete = log.completed;
        scope.rowData.completeText = resource.resource_type === 'assessment' ? 'assessment' : 'lesson';
      }
      else    {
        scope.rowData.isComplete = false;
        scope.rowData.completeText = 'This in progress and was started '
      }
      scope.rowData.studentName = student.display_name
      scope.rowData.resourceName = resource.name

      if (log.completed) {
        if( scope.rowData.completeText === 'lesson') {
          if (scope.rowData.timeText.indexOf('day') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27738'
          } else if (scope.rowData.timeText.indexOf('month') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27739'
          } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
            scope.rowData.compiledTimeSentenceID = '28504'
          } else {
            scope.rowData.compiledTimeSentenceID = '28505'
          }
        }
        else {
          if (scope.rowData.timeText.indexOf('day') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27740'
          } else if (scope.rowData.timeText.indexOf('month') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27739'
          } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
            scope.rowData.compiledTimeSentenceID = '28506'
          } else {
            scope.rowData.compiledTimeSentenceID = '28507'
          }
        }
      }
      else {
        if( scope.rowData.completeText === 'lesson') {
          if (scope.rowData.timeText.indexOf('day') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27736'
          } else if (scope.rowData.timeText.indexOf('month') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27737'
          } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
            scope.rowData.compiledTimeSentenceID = '28502'
          } else {
            scope.rowData.compiledTimeSentenceID = '28503'
          }
        }
        else {
          if (scope.rowData.timeText.indexOf('day') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27742'
          } else if (scope.rowData.timeText.indexOf('month') >= 0) {
            scope.rowData.compiledTimeSentenceID = '27743'
          } else if (scope.rowData.timeText.indexOf('hour') >= 0) {
            scope.rowData.compiledTimeSentenceID = '28508'
          } else {
            scope.rowData.compiledTimeSentenceID = '28509'
          }
        }
      }
      // scope.rowData.text = scope.getTranslation(scope.rowData.compiledTimeSentenceID).replace('x', scope.rowData.timeAgoNumber);
      scope.cardStatus = scope.rowData.inProgress ? 'in-progress' : (scope.rowData.isComplete ? 'complete' : '');
      scope.loadingStatus.done = true;
      scope.loadingStatus.error = false;
      scope.loadingStatus.processing = false;
      scope.rowData.slug = log.slug
      scope.rowData.resource_type = log.resource_type
      scope.rowData.name = log.name
      getCompleteStarCount(resource);
      getMaxStarCount(resource);
      eventManager.broadcast('teacherStudentWorkspace:studentFilter:request');
    }

    var init = function(){
      scope.loadingStatus.done = false;
      scope.loadingStatus.error = false;
      scope.loadingStatus.processing = true;
      // $q.all([
      //   TeacherDataService.getClassStudentMap(scope.classId, null, true, false).then(function(students){
          infoMaps.users = scope.studentsList
      //   }),
      //   TeacherDataService.getModuleResourceListFlatMap(scope.classId).then(function(resources){
          infoMaps.resources = scope.resourceListing;//scope.resourcesList
      //   })
      // ]).then(function(){
        // scope.fbRef = Firebase.database().ref(['timeline', scope.classId, scope.log.$id].join('/'));
        // ['value', 'child_added', 'child_changed', 'child_removed', 'child_moved'].map(function(eventName){
        //     scope.fbRef.on(eventName, function(snap){
        //         scope.fbRef.once('value', function(snap){
        //             // console.log(snap.val())
        //             parseLog(snap.val())
        //         }).catch(function(err){
        //             $log.error(err);
        //             scope.loadingStatus.done = true;
        //             scope.loadingStatus.error = true;
        //         })
        //     })
        // })
        parseLog(scope.log);
      // }).catch(function(err){
      //   $log.error(err);
      //   scope.loadingStatus.done = true;
      //   scope.loadingStatus.error = true;
      // })
    }
    init();
    // language.resetAvilableOptions();
  }

}})
